import { array, boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { CountryCode } from '../country';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,

		countryCodes: array(CountryCode),
		hasMultipleOrganizations: boolean,

		isDeleted: boolean,
		isUnknown: boolean,
	})
);
